import './../../styles/Account.css';

import { useEffect, useState } from 'react';

import Container from '../../components/Layout/Container';

import { Checkbox } from '../../components/CheckboxRadio/Checkbox';
import { Button } from '../../components/Button/Button';

import { fetchGet } from '../../hooks/fetch';
import { openAlert } from '../../components/Modal/MsgBox';

export default function Signup() {
	const pageName = '회원가입';

	const [termsCondition, setTermsCondition] = useState({});
	const [personalInfo, setPersonalInfo] = useState({});

	function getPolicies() {
		fetchGet(
			"/users/policy",
			(json) => {
				setTermsCondition(json.termsCondition);
				setPersonalInfo(json.personalInfo);
			}
		)
	}

	const [termsConditionsCheck, setTermsConditionsCheck] = useState(false); // 이용약관 동의
	const [collectPersonalInfoCheck, setCollectPersonalInfoCheck] = useState(false); // 개인정보 수집 동의

	function checkForm() {
		if(!termsConditionsCheck) {
			openAlert("이용약관에 동의해 주세요.");
			return;
		}

		if(!collectPersonalInfoCheck) {
			openAlert("개인정보 수집에 동의해 주세요.");
			return;
		}

		window.location.href = './signup/request'
	}

	useEffect(() => {
		getPolicies();
	}, []);

	return (
		<main id="account-page-wrap">
			<h1 className="sr-only">{`${pageName} 동의 페이지`}</h1>

			<Container>
				<div className="page-content sign-up-page">
					<form action="" className="form">
						<div>
							<h2>{pageName}</h2>
							<div>
								<div className="agree-txt">
									{termsCondition?.content?.includes("<") 
										? <div dangerouslySetInnerHTML={{ __html: termsCondition?.content }} />
										: <pre>{termsCondition.content}</pre>
									}
								</div>
								<div>
									<Checkbox
										value="terms-conditions"
										checked={termsConditionsCheck}
										onChange={() => setTermsConditionsCheck(!termsConditionsCheck)}
									>
										<span className="fc-cerulean-blue">[필수]</span> 이용약관에 동의 합니다.
									</Checkbox>
								</div>
							</div>
							<div>
								<div className="agree-txt">
									{personalInfo?.content?.includes("<")
										? <div dangerouslySetInnerHTML={{ __html: personalInfo?.content }} />
										: <pre>{personalInfo.content}</pre>
									}
								</div>
								<div>
									<Checkbox
										value="collect-personal-info"
										checked={collectPersonalInfoCheck}
										onChange={() =>
											setCollectPersonalInfoCheck(!collectPersonalInfoCheck)
										}
									>
										<span className="fc-cerulean-blue">[필수]</span> 개인정보 수집 및 이용에 동의 합니다.
									</Checkbox>
								</div>
							</div>
						</div>

						<div className="gs-bottom-btns">
							{/* <Link to="./../SignupRequest" className="gs-btn">
								<strong>다 음</strong>
							</Link> */}

							<Button type="button" className="gs-btn" onClick={checkForm}>
								<strong>다 음</strong>
							</Button>
						</div>
					</form>
				</div>
			</Container>
		</main>
	);
}
